module.exports = function isArray(value) {
  return require("@is-(unknown)/is-array")(value)
}